import {
  Avatar,
  Button,
  Divider,
  Link,
  Stack,
  Typography,
} from '@mui/material';
import { ISubCategory } from 'API/UniversalRequest/universalRequest';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { AccordionArrowBlue, ExternalLink } from 'Images';
import { useState } from 'react';
import { TAB_VALUE_TYPE } from '..';
import { useIsDesktop } from 'Hooks';

interface ISubCategoriesHeaderContent {
  getParentTitleById: string;
  getSubtitleObj?: ISubCategory;
  tabValue: number;
}

export const SubCategoriesHeaderContent = ({
  getParentTitleById,
  getSubtitleObj,
  tabValue,
}: ISubCategoriesHeaderContent) => {
  const [showExtendedText, setShowExtendedText] = useState(false);
  const dictionary = Dictionary[DICTIONARY.UniversalRequest];
  const isDesktop = useIsDesktop();

  return (
    <>
      <Stack
        direction={'row'}
        width={isDesktop ? '600px' : '100%'}
        gap={3}
        mr={isDesktop ? undefined : '24px'}
        alignItems={'center'}
      >
        <Stack>
          {!isDesktop && (
            <Typography component={'h2'} variant={'body6'}>
              {tabValue === TAB_VALUE_TYPE.DEPARTMENT
                ? dictionary.subject2
                : dictionary.subject}
            </Typography>
          )}
          <Stack
            gap='12px'
            direction='row'
            justifyContent={isDesktop ? 'center' : 'flex-start'}
            alignItems='center'
          >
            {getParentTitleById && (
              <Stack
                direction='row'
                gap='4px'
                alignItems={isDesktop ? 'center' : 'flex-start'}
                width='fit-content'
              >
                {isDesktop && (
                  <Typography component={'h2'} variant={'body6'}>
                    {tabValue === TAB_VALUE_TYPE.DEPARTMENT
                      ? dictionary.subject2
                      : dictionary.subject}
                  </Typography>
                )}
                <Typography variant='body2'>{getParentTitleById}</Typography>
              </Stack>
            )}
            {getSubtitleObj && (
              <>
                <Divider
                  orientation='vertical'
                  flexItem
                  sx={{ borderColor: '#C6CAD4' }}
                />
                <Typography variant='body2'>{getSubtitleObj.title}</Typography>
              </>
            )}
            {getSubtitleObj?.description && (
              <Link
                component='button'
                sx={{
                  textDecoration: 'underline',
                  width: 'auto',
                  '&:hover': { textDecoration: 'underline' },
                  display: 'flex',
                  mt: 3,
                  mb: 2,
                }}
                onClick={() => setShowExtendedText(!showExtendedText)}
              >
                <Typography variant={'body3'}>
                  {showExtendedText
                    ? dictionary.uploadFile.closeLabel
                    : dictionary.uploadFile.extendLabel}
                </Typography>
                <Avatar
                  src={AccordionArrowBlue}
                  alt={''}
                  sx={{
                    width: '22px',
                    height: '22px',
                    margin: '0 8px',
                    transform: showExtendedText ? 'rotate(180deg)' : undefined,
                  }}
                />
              </Link>
            )}
          </Stack>
        </Stack>
      </Stack>
      <Stack
        sx={{
          p: isDesktop ? undefined : '0 20px',
          mt: showExtendedText ? '-80px' : undefined,
        }}
      >
        {showExtendedText && (
          <Stack
            sx={{
              margin: '20px auto',
              width: 'auto',
              maxWidth: '680px',
            }}
          >
            <Typography variant={'body3'}>
              {getSubtitleObj?.description}
            </Typography>
            <Button
              sx={{
                width: '138px',
                height: '46px',
                margin: '16px 0',
                borderRadius: '8px',
                bgcolor: 'white',
              }}
              variant='outlined'
              startIcon={
                <Avatar
                  src={ExternalLink}
                  alt={''}
                  sx={{ width: '20px', height: '20px' }}
                />
              }
              href={getSubtitleObj?.descriptionLink}
            >
              <Typography variant={'body5'}>
                {dictionary.uploadFile.externalLinkLabel}
              </Typography>
            </Button>
          </Stack>
        )}
      </Stack>
    </>
  );
};
